import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { UserListComponent } from '../admin-management/components/user-list/user-list.component';
import { PageTitle } from '@app/commons/utils/enums';
import { AuthGuard } from '@app/guards/auth.guard';
import { AdminManagementComponent } from './container/admin-management/admin-management.component';
import { ChatbotListComponent } from './container/chatbot-list/chatbot-list.component';
import { ChatbotDetailComponent } from './container/chatbot-detail/chatbot-detail.component';

const routes: Routes = [
  {
    path: 'admin',
    canActivate: [AuthGuard],
    data: { title: PageTitle.UserList, requiresAdmin: true },
    component: AdminManagementComponent,
    children: [
        {
            path: 'users',
            component: UserListComponent,
            canActivate: [AuthGuard],
            data: { title: PageTitle.UserList },
        },
        {
            path: "chatbot-management",
            canActivate: [AuthGuard],
            component: ChatbotListComponent,
        },
    ],
  },
  {
    path: "admin/chatbot-management/:id",
    data: { requiresAdmin: true },
    canActivate: [AuthGuard],
    component: ChatbotDetailComponent,
  },

];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AdminManagementRoutingModule {}
